import { images } from "./images";
import { Category, CategoryDetails, MetaTagsProps } from "@/types";
import { Camera } from "lucide-react";
import { OG_PATH, WEBSITE_URL } from "@/content";
import {
  createImageItems,
  electronicCategoryPoints,
} from "@/content/services/service-content-helpers";
import { category as service1, createMetaTags as tags1 } from "./1";
import { category as service2, createMetaTags as tags2 } from "./2";
import { category as service3, createMetaTags as tags3 } from "./3";
import { category as service4, createMetaTags as tags4 } from "./4";
import { category as service5, createMetaTags as tags5 } from "./5";

const slug = "electronic-security-solutions-sydney";

export const headCategory: Category = {
  id: 1,
  key: "electronic",
  name: "Electronic Security Solutions Sydney",
  long_name: "Electronic Security Solutions Sydney",
  slug,
  categoryType: "services",
};

export const metaTags: MetaTagsProps = {
  title: "Electronic Security Solutions Sydney | Ozy Wide Group",
  description:
    "Electronic security solutions for Sydney homes, businesses, strata entries, yards and workplaces. Ozy Wide Group helps with CCTV, alarms, intercoms, access control and automatic gates that are planned around real access points, routines and risks.",
  keywords:
    "electronic security Sydney, CCTV installation Sydney, alarm systems Sydney, intercom systems Sydney, access control Sydney, automatic security gates",
  url: `${WEBSITE_URL}/${headCategory.categoryType}/${headCategory.slug}/`,
  ogImage: `${OG_PATH}service-category-electronic-security-solutions-sydney.jpg`,
  type: "website",
};

export const subCategoryObject = Object.fromEntries(
  Object.entries({
    category1Service1: { ...service1, ...tags1(metaTags) },
    category1Service2: { ...service2, ...tags2(metaTags) },
    category1Service3: { ...service3, ...tags3(metaTags) },
    category1Service4: { ...service4, ...tags4(metaTags) },
    category1Service5: { ...service5, ...tags5(metaTags) },
  }).map(([key, value]) => [key, { ...value, headCategory }]),
);

const subCategories = Object.values(subCategoryObject);

export const categoryDetails: CategoryDetails = {
  ...headCategory,
  metaTags,
  order: 1,
  icon: Camera,
  description: [
    "Electronic security solutions for Sydney homes, businesses, strata entries, yards and workplaces. Ozy Wide Group helps with CCTV, alarms, intercoms, access control and automatic gates that are planned around real access points, routines and risks.",
  ],
  points: electronicCategoryPoints,
  content: [
    {
      id: 1,
      title: "Electronic Security Solutions Sydney in Sydney",
      content:
        "Electronic security solutions for Sydney homes, businesses, strata entries, yards and workplaces. Ozy Wide Group helps with CCTV, alarms, intercoms, access control and automatic gates that are planned around real access points, routines and risks.",
      points: [
        "CCTV, alarm and access planning",
        "Entry, perimeter and visitor control",
        "Maintenance-aware system setup",
      ],
    },
  ],
  videos: [],
  images: createImageItems(images, "Electronic Security Solutions Sydney"),
  subCategories,
};
